<template>
  <div  @click.stop>
    <div class="column-acoes">
      <el-dropdown trigger="click" :disabled="this.desabilitaAbrirAcoes">
        <span style="user-select: none; cursor: pointer" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="el-dropdown-link" :class="{ 'is-disabled': this.desabilitaAbrirAcoes }">
          <slot>
            Ações <i class="el-icon-more"></i>
          </slot>
        </span>
        <el-dropdown-menu slot="dropdown" class="acoes-dropdown">
          <el-dropdown-item v-for="(acao, index) in columnAcoes" :key="index">
            <el-button v-show="('show' in acao)? acao.show : true" type="text" @click="acao.func(row)">{{acao.label}}</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="text"></el-button>
    </div>
    <ModalEnvio
      :open.sync="mostraEnvio"
      title="Selecionar Envio"
      width="523px"
      @close="mostraEnvio = false"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :payloadWidget="()=>{return carregaPayloadWidget(row)}"
    />
  </div>
</template>
<style scoped>
.is-disabled {
  color: #bbb !important;
  pointer-events: none !important;
}
</style>
<script>
import { mapGetters, mapState } from 'vuex'
import ModalEnvio from '@/components/ModalEnvio/ModalEnvio'
import { preloadWidget } from '@/views/4/PreLoadWidget4'

export default {
  name: 'AcoesRedeCredenciada',
  props: {
    row: {
      type: Object,
      required: true
    },
    abreDetalhe: {
      type: Function,
      default: null
    }
  },
  components: { ModalEnvio },
  data () {
    return {
      mostraEnvio: false,
      payloadWidget: {}
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'canalAtendimentoOrigem', 'isWidget']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'frameId', 'embedJson']),
    columnAcoes () {
      return this.isWidget ? this.menuMosiaDesk : {}
    },
    menuMosiaDesk () {
      const payloadMenu = []
      if (
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget ||
        this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget
      ) {
        payloadMenu.push({ label: 'Enviar', func: this.abreDialogEnvio })
      }
      if (this.funcionalidade.parametros.configuracoesDeWidgets.exibeDetalheWidget && this.abreDetalhe) {
        payloadMenu.push({ label: 'Detalhes', func: this.abreDetalhe })
      }
      return payloadMenu
    },
    desabilitaEnviar () {
      return !(this.opcaoEnvio !== '' && (this.escolhasEnvio.length > 0))
    },
    desabilitaAbrirAcoes () {
      return (!this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget &&
        !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget &&
        !this.funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget)
    }
  },
  methods: {
    async abreDialogEnvio () {
      this.mostraEnvio = true
    },
    carregaPayloadWidget (row) {
      return preloadWidget(
        this.aplicacao.idOperadora,
        row.id || row.id_prestador,
        this.funcionalidade.agrupaEspecialidades,
        this.funcionalidade,
        this.embedJson.atendimento.tokenAtendente
      )
    }
  }
}
</script>
